export default __webpack_public_path__ + "assets/images/49cb73b4543da9f891fabd55bc59aded.svg";